/**
 * 省市区选择器 mixin。
 * 提供 selectedProvince/City/District 选中态、provinceOptions/cityOptions/districtOptions 选项、
 * 以及切换省/市时的联动重置逻辑。复用 utils/areaData 的单一数据源。
 *
 * 用法：在需要地址选择器的组件里 mixins: [areaSelector]。
 * 组件模板用 q-select 绑 selectedProvince/City/District，options 绑 provinceOptions/cityOptions/districtOptions，
 * 省市 @input 绑 onProvinceChange/onCityChange。
 */
import { provinceOptions as PROVINCE_OPTS, cityMap, districtMap } from '@/utils/areaData'

export default {
  data () {
    return {
      selectedProvince: '广西壮族自治区',
      selectedCity: '贺州市',
      selectedDistrict: '八步区'
    }
  },
  computed: {
    provinceOptions () {
      return PROVINCE_OPTS
    },
    cityOptions () {
      if (!this.selectedProvince || !cityMap[this.selectedProvince]) return []
      return cityMap[this.selectedProvince].map(city => ({ label: city, value: city }))
    },
    districtOptions () {
      if (!this.selectedCity || !districtMap[this.selectedCity]) return []
      return districtMap[this.selectedCity].map(d => ({ label: d, value: d }))
    }
  },
  methods: {
    onProvinceChange (province) {
      const cities = cityMap[province] || []
      if (cities.length > 0 && !cities.includes(this.selectedCity)) {
        this.selectedCity = cities[0]
      }
      this.selectedDistrict = ''
    },
    onCityChange (city) {
      this.selectedDistrict = ''
      if (districtMap[city] && districtMap[city].length > 0) {
        this.selectedDistrict = districtMap[city][0]
      }
    }
  }
}
